import { createProject } from './createProjectThunk';
export default createProject;
